<template>
    <SettingsPage title="Dashboard Settings">
        <template v-slot:settingsForms>
            <!-- Platform User (basic, premium, plus) Dashboard -->
            <SettingsForm :settingsLoading="settingsLoading" form="userDashboardSettings">
                <template v-slot:title>
                    User Dashboard
                </template>
                <template v-slot:form>
                    <form action="" method="POST" id="userDashboardSettings" @submit.prevent="saveUserDashboard" v-if="!settingsLoading && settings">
                        <v-text-field label="Dashboard Title"
                                      name="userDashboardTitle"
                                      v-model="settings.userDashboardTitle"
                                      outlined
                        ></v-text-field>
                        <v-text-field label="Dashboard Subtitle"
                                      name="userDashboardSubtitle"
                                      v-model="settings.userDashboardSubtitle"
                                      outlined
                        ></v-text-field>
                        <v-text-field label="Notification"
                                      name="userDashboardNotification"
                                      v-model="settings.userDashboardNotification"
                                      outlined
                        ></v-text-field>
                        <v-text-field label="Welcome Video Embed ID"
                                      name="userDashboardWelcomeVideoEmbed"
                                      v-model="settings.userDashboardWelcomeVideoEmbed"
                                      outlined
                        ></v-text-field>
                        <label for="userDashboardWelcomeText">Welcome Text</label>
                        <quill-editor label="Welcome Text"
                                      id="userDashboardWelcomeText"
                                      name="userDashboardWelcomeText"
                                      v-model="settings.userDashboardWelcomeText"
                                      outlined
                        ></quill-editor>
                    </form>
                </template>
            </SettingsForm>

            <!-- Support Dashboard -->
            <SettingsForm :settingsLoading="settingsLoading" form="supportDashboardSettings">
                <template v-slot:title>
                    Support Dashboard
                </template>
                <template v-slot:form>
                    <form action="" method="POST" id="supportDashboardSettings" @submit.prevent="saveSupportDashboard" v-if="!settingsLoading && settings">
                        <v-text-field label="Dashboard Title"
                                      name="supportDashboardTitle"
                                      v-model="settings.supportDashboardTitle"
                                      outlined
                        ></v-text-field>

                        <v-text-field label="Dashboard Subtitle"
                                      name="supportDashboardSubtitle"
                                      v-model="settings.supportDashboardSubtitle"
                                      outlined
                        ></v-text-field>

                        <v-text-field label="Notification"
                                      name="supportDashboardNotification"
                                      v-model="settings.supportDashboardNotification"
                                      outlined
                        ></v-text-field>

                        <v-text-field label="Welcome Video Embed ID"
                                      name="userDashboardWelcomeVideoEmbed"
                                      v-model="settings.supportDashboardWelcomeVideoEmbed"
                                      outlined
                        ></v-text-field>

                        <label for="supportDashboardWelcomeText">Welcome Text</label>
                        <quill-editor label="Welcome Text"
                                      id="supportDashboardWelcomeText"
                                      name="supportDashboardWelcomeText"
                                      v-model="settings.supportDashboardWelcomeText"
                                      outlined
                        ></quill-editor>

                        <v-row dense>
                            <v-col cols="12" md="3">
                                <h3 class="mb-2">Button 1</h3>
                                <v-autocomplete label="Page"
                                                :items="navigationLinks"
                                                item-text="name"
                                                item-value="id"
                                                name="page1"
                                                v-model="settings.button1.navItem"
                                                outlined
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="3">
                                <h3 class="mb-2">Button 2</h3>
                                <v-autocomplete label="Page"
                                                :items="navigationLinks"
                                                item-text="name"
                                                item-value="id"
                                                name="page2"
                                                v-model="settings.button2.navItem"
                                                outlined
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="3">
                                <h3 class="mb-2">Button 3</h3>
                                <v-autocomplete label="Page"
                                                :items="navigationLinks"
                                                item-text="name"
                                                item-value="id"
                                                name="page3"
                                                v-model="settings.button3.navItem"
                                                outlined
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="3">
                                <h3 class="mb-2">Button 4</h3>
                                <v-autocomplete label="Page"
                                                :items="navigationLinks"
                                                item-text="name"
                                                item-value="id"
                                                name="page3"
                                                v-model="settings.button4.navItem"
                                                outlined
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </form>
                </template>
            </SettingsForm>
        </template>
    </SettingsPage>
</template>

<script>
import settingsMixin from '@/views/Admin/Config/Settings/Common/settingsMixin';
import SettingsForm from '@/views/Admin/Config/Settings/Common/SettingsForm';
import SettingsPage from '@/views/Admin/Config/Settings/Common/SettingsPage';
import axios from 'axios';

export default {
    mixins: [ settingsMixin ],
    components: { SettingsPage, SettingsForm },
    props: [],

    data() {
        return {
            settingPage: 'dashboard',
            settingName: 'settingDashboard',
            postData: {},
            navigationLinks: [],
        };
    },

    mounted() {
        this.getNavigationLinks();
    },

    methods: {
        getNavigationLinks() {
            axios.get('/api/navigation-link/index')
                .then(response => {
                    this.navigationLinks = response.data.data.navigationLinks.links;
                    console.log(this.navigationLinks);
                })
                .catch(error => {
                    console.error(error);
                });
        },

        saveUserDashboard() {
            const settings = {
                userDashboardNotification: this.settings.userDashboardNotification,
                userDashboardWelcomeVideoEmbed: this.settings.userDashboardWelcomeVideoEmbed,
                userDashboardWelcomeText: this.settings.userDashboardWelcomeText,
                userDashboardSubtitle: this.settings.userDashboardSubtitle,
                userDashboardTitle: this.settings.userDashboardTitle,
                userDashboardNotificationButtonUrl: this.settings.userDashboardNotificationButtonUrl,
            };

            this.saveSettings(this.settingPage, this.setPostData(`${this.settingName}User`, settings));
        },

        saveSupportDashboard() {
            const settings = {
                supportDashboardNotification: this.settings.supportDashboardNotification,
                supportDashboardWelcomeVideoEmbed: this.settings.supportDashboardWelcomeVideoEmbed,
                supportDashboardWelcomeText: this.settings.supportDashboardWelcomeText,
                supportDashboardSubtitle: this.settings.supportDashboardSubtitle,
                supportDashboardTitle: this.settings.supportDashboardTitle,
                supportDashboardNotificationButtonUrl: this.settings.supportDashboardNotificationButtonUrl,

                button1: {
                    navItem: this.settings.button1.navItem,
                },

                button2: {
                    navItem: this.settings.button2.navItem,
                },

                button3: {
                    navItem: this.settings.button3.navItem,
                },

                button4: {
                    navItem: this.settings.button4.navItem,
                },
            };

            this.saveSettings(this.settingPage, this.setPostData(`${this.settingName}Support`, settings));
        }
    }
};
</script>
